
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lead-management/[[...listingAlias]]",
      function () {
        return require("private-next-pages/lead-management/[[...listingAlias]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lead-management/[[...listingAlias]]"])
      });
    }
  